// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bea_a bhs_b bhs_va bhs_rv bhs_rw bhs_vu","PanelFooter--link":"bea_b"};